<template>
  <div class="monitorWarning">
    <div class="lineCon">
      <el-tabs v-model="activeMask" type="card" class="demo-tabs" @tab-click="handleClick">
        <template v-for="(item, index) in deviceList">
          <el-tab-pane :label="item.deviceName" :name="item.deviceMask">
            <template #label>
              <div
                class="lineItem"
                :style="{
                  backgroundColor: activeMask === item.deviceMask ? item.selectedColor : item.color
                }"
                :id="'lineItem' + index"
                @click="checkNum=index"
              >
                <img
                  src="./img/checked.png"
                  class="checked"
                  v-if="activeMask === item.deviceMask"
                />
                {{ item.deviceName }}
              </div>
            </template>
            <template></template>
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
    <div class="content" v-if="activeId == 0" >
      <allTab :deviceList="deviceList"></allTab>
    </div>
    <div class="content" v-else>
      <div class="left">
        <el-tabs tab-position="left" v-model="contentName">
          <el-tab-pane label="环境监测" name="first">
            <FirstTab
              v-if="contentName === 'first'"
              ref="firstTabRef"
              :activeMask="activeMask"
              :checkNum="checkNum"
              key="first"
            ></FirstTab>
          </el-tab-pane>
          <el-tab-pane label="线路监测" name="second">
            <SecondTab
              v-if="contentName === 'second'"
              ref="secondTabRef"
              :activeId="activeId"
              key="second"
            ></SecondTab>
          </el-tab-pane>
          <el-tab-pane label="远程运维" name="third">
            <ThirdTab
              v-if="contentName === 'third'"
              ref="thirdTabRef"
              :activeMask="activeMask"
              :checkNum="checkNum"
              key="third"
            ></ThirdTab>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        deviceList: [],
        activeMask: '',
        contentName: 'first',
        activeId: 0,
        checkNum:0,
      }
    },
    components: {
      FirstTab: () => import('./tabComponents/firstTab'),
      SecondTab: () => import('./tabComponents/secondTab'),
      ThirdTab: () => import('./tabComponents/thirdTab'),
      allTab: () => import('./tabComponents/allTab'),
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        const colorList = [
          {
            color: 'rgba(0, 154, 213, 0.5)',
            markColor: 'rgba(5, 154, 213, 0.4)',
            selcetedColor: '#059ad5'
          },
          {
            color: 'rgba(18, 192, 208, 0.5)',
            markColor: 'rgba(18, 192, 208, 0.4)',
            selectedColor: '#12c0d0'
          },
          {
            color: 'rgba(61, 182, 127, 0.5)',
            markColor: 'rgba(61, 182, 127, 0.4)',
            selectedColor: '#3db67f'
          },
          {
            color: 'rgba(33, 186, 162, 0.5)',
            markColor: 'rgba(33, 186, 162, 0.4)',
            selectedColor: '#21baa2'
          },
          {
            color: 'rgba(214, 147, 51, 0.5)',
            markColor: 'rgba(214, 147, 51, 0.4)',
            selectedColor: '#d69333'
          }
        ]

        const convertToLength = (colorList, n) => {
          let result = colorList.slice(0, n)
          while (result.length < n) {
            result.push(...colorList.slice(0, n - result.length))
          }

          return result
        }
        this.$axiosget('operation/fireDetectorReport/getDeviceDropDownByTypeDesc/zhydqhz').then(
          res => {
            if (res.data.status == 10000) {
              const colorNewList = convertToLength(colorList, res.data.data.length+1)
              this.deviceList = res.data.data.map((item, index) => {
                return {
                  ...item,
                  color: colorNewList[index+1].color,
                  markColor: colorNewList[index+1].markColor,
                  selectedColor: colorNewList[index+1].selectedColor
                }
              })
              console.log(this.deviceList);
              this.deviceList.unshift({
                "deviceName": "全部",
                "deviceId": 0,
                "deviceMask": "0",
                color: colorNewList[0].color,
                markColor: colorNewList[0].markColor,
                selectedColor: colorNewList[0].selectedColor
              })
              if (this.deviceList.length > 0) {
                this.activeMask = this.deviceList[0].deviceMask
              }
              this.activeId = this.deviceList[0].deviceId
            }
          }
        )
      },
      handleClick() {
        this.activeId = this.deviceList.find(item => item.deviceMask == this.activeMask).deviceId
      }
    }
  }
</script>

<style lang="less" scoped>
  .monitorWarning {
    height: 97%;

    .lineCon {
      width: 100%;
      height: 0.83rem;
      position: relative;
      background-color: #253253;
      margin: 0.2rem 0.1rem;
      padding: 0 0.34rem;
      .lineList {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        overflow-x: scroll;
      }

      .lineItem {
        flex-shrink: 0;
        min-width: 1.35rem;
        padding: 0 0.1rem;
        height: 0.36rem;
        text-align: center;
        line-height: 0.36rem;
        background-color: #059ad5;
        margin-right: 0.15rem;
        font-family: 'MicrosoftYaHei';
        font-size: 0.16rem;
        color: #fff;
        position: relative;
        cursor: pointer;

        .checked {
          position: absolute;
          right: 0;
          top: 0;
          width: 0.22rem;
          height: 0.22rem;
        }
      }
    }

    /deep/ .demo-tabs {
      width: 100%;
      height: 100%;

      .el-tabs__header {
        height: 100%;
        border: 0;
        margin: 0;
        display: flex;
        align-items: center;

        .el-tabs__nav-wrap.is-scrollable {
          padding: 0 0.2rem;

          .el-icon {
            font-size: 0.14rem;
            color: #fff;
          }
        }

        .el-tabs__nav {
          border: 0;
        }

        .el-tabs__item {
          padding: 0;
          margin-right: 0.15rem;
          border: 0;

          .lineItem {
            margin-right: 0;
          }

          &:focus-visible {
            box-shadow: none;
            border-radius: 0;
          }
        }

        .el-tabs__item:nth-child(2),
        .el-tabs__item:last-child {
          padding: 0;
        }
      }

      .el-tabs__content {
        display: none;
      }

      .el-tabs__nav {
        border: none;
      }
    }

    .content {
      height: calc(100% - 0.83rem - 0.4rem);
      display: flex;

      .left {
        width: 100%;
      }

      .el-tabs--left,
      .el-tabs--right {
        height: 100%;
        display: flex;
      }

      /deep/.el-tabs--left .el-tabs__header.is-left {
        width: 2.5rem;
      }
      /deep/.el-tabs--left .el-tabs__item.is-left {
        padding: 0px;
        width: 2.5rem;
        height: 0.51rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.18rem;
        margin-bottom: 0.1rem;
      }
      /deep/ .el-tabs__item {
        color: #fff;
        background: url('./img/whitejiantou.png') no-repeat;
        background-position: 74% center;
        background-size: 2.6%;
      }
      /deep/ .el-tabs__item.is-active {
        background: url('./img/bodyleft.png') no-repeat center;
        background-size: cover;
        color: #fff;
      }
      /deep/ .el-tabs__content {
        width: 100%;
        .el-tab-pane {
          height: 100%;
        }
      }
      /deep/ .el-tabs__header {
        margin-right: 0.25rem;
      }
    }
    /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
      width: 0px;
    }

    /deep/ .el-tabs--left .el-tabs__active-bar.is-left {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute1/monitorWarning/index.vue